// import React from "react";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";

// import PageTitle from "components/Typography/PageTitle";
// import OverAllNotifcationCardUI from "components/notification/OverAllNotifcationCardUI";
// import { IoNotificationsOutline } from "react-icons/io5";
// import sidebar from "../routes/sidebar";
// import useGetAllNotification from "hooks/useGetAllNotification";

// const OverallNotification = () => {
//   const { allNotifications, loading } = useGetAllNotification();

//   return (
//     <>
//       <PageTitle sidebar={sidebar().sidebar} />

//       <div className="bg-gray-50 min-h-screen py-8">
//         <div className="w-11/12 lg:w-8/12 mx-auto">
//           <div className="sticky top-0 z-20 bg-white rounded-xl shadow-sm p-5 mb-5 flex items-center justify-between">
//             <div>
//               <h2 className="text-md font-semibold text-gray-800">
//                 Notifications
//               </h2>

//               <p className="text-sm text-gray-500 mt-0.5">
//                 You have{" "}
//                 <span className="font-semibold text-gray-700">
//                   {loading ? "--" : allNotifications?.length || 0}
//                 </span>{" "}
//                 notifications
//               </p>
//             </div>

//             <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center">
//               <IoNotificationsOutline className="text-2xl text-blue-600" />
//             </div>
//           </div>

//           <div
//             className="max-h-[75vh] overflow-y-auto hide-scrollbar space-y-4 pr-2"
//             style={{
//               scrollbarWidth: "none",
//               msOverflowStyle: "none",
//             }}
//           >
//             {loading &&
//               Array.from({ length: 6 }).map((_, index) => (
//                 <div
//                   key={index}
//                   className="bg-white rounded-lg border border-gray-200 p-4 shadow-sm"
//                 >
//                   <div className="flex gap-3">
//                     <Skeleton circle width={40} height={40} />

//                     <div className="flex-1">
//                       <Skeleton width={180} height={18} />
//                       <Skeleton
//                         count={2}
//                         className="mt-2"
//                       />
//                     </div>

//                     <Skeleton width={70} height={14} />
//                   </div>
//                 </div>
//               ))}

//             {!loading &&
//               allNotifications?.length > 0 &&
//               allNotifications.map((item) => (
//                 <OverAllNotifcationCardUI
//                   key={item.id}
//                   data={item}
//                   from={'all'}
//                 />
//               ))}

//             {!loading && (!allNotifications || allNotifications.length === 0) && (
//               <div className="flex flex-col items-center justify-center py-16">
//                 <img
//                   src="/images/no-notification.svg"
//                   alt="No Notifications"
//                   className="w-56 mb-5"
//                 />

//                 <h3 className="text-lg font-semibold text-gray-700">
//                   No Notifications Found
//                 </h3>

//                 <p className="text-sm text-gray-500 mt-2 text-center">
//                   You're all caught up. There are no notifications available.
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default OverallNotification;



import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import PageTitle from "components/Typography/PageTitle";
import OverAllNotifcationCardUI from "components/notification/OverAllNotifcationCardUI";
import { IoNotificationsOutline } from "react-icons/io5";
import sidebar from "../routes/sidebar";
import NoNotification from '../assets/img/no-notification.svg'

import { MdOutlineDelete } from "react-icons/md";
import FranchisePageServices from "services/FranchiseService";
import getEmployeeId from "utils/commonAdmin";
import { useState } from "react";
import NotificationServices from "services/NotificationServices";
import { useNotification } from "context/NotificationContext";

const OverallNotification = () => {
  const {
    allNotifications,
    loading,
    fetchNotifications,
    deleteNotification,
    updateNotificationStatus,
  } = useNotification();

const [deleteLoading, setDeleteLoading] = useState(false);

const handleBulkDelete = async () => {
  if (deleteLoading) return;

  try {
    setDeleteLoading(true);

    const id_employee = await getEmployeeId();

    const payload = {
      receiver: id_employee,
    };

    await NotificationServices.notificationDeleteNew(payload);

    await fetchNotifications();

    console.log("All notifications deleted");
  } catch (err) {
    console.error(err);
  } finally {
    setDeleteLoading(false);
  }
};

  return (
    <>
      <PageTitle sidebar={sidebar().sidebar} />

      <div className="bg-gray-50 min-h-screen py-8">
        <div className="w-11/12 lg:w-8/12 mx-auto">
          <div className="sticky top-0 z-20 bg-white rounded-xl shadow-sm p-5 mb-5 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center">
                <IoNotificationsOutline className="text-2xl text-blue-600" />
              </div>
              <div>
                <h2 className="text-md font-semibold text-gray-800">
                Notifications
              </h2>

              <p className="text-sm text-gray-500 mt-0.5">
                You have{" "}
                <span className="font-semibold text-gray-700">
                  {loading ? "--" : allNotifications?.length || 0}
                </span>{" "}
                notifications
              </p>
              </div>
            </div>
            <div className="rounded-full text-sm px-2 py-1 cursor-pointer bg-red-50 text-red-600 flex items-center justify-center" onClick={()=>handleBulkDelete()}>
              <MdOutlineDelete />
              <span>Delete All</span>
            </div>
          </div>

          <div
            className="max-h-[75vh] overflow-y-auto hide-scrollbar space-y-4 pr-2"
            style={{
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >

            {loading &&
              Array.from({ length: 6 }).map((_, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg border border-gray-200 p-4 shadow-sm"
                >
                  <div className="flex gap-3">
                    <Skeleton
                      circle
                      width={40}
                      height={40}
                    />

                    <div className="flex-1">
                      <Skeleton
                        width={180}
                        height={18}
                      />

                      <Skeleton
                        count={2}
                        className="mt-2"
                      />
                    </div>

                    <Skeleton
                      width={70}
                      height={14}
                    />
                  </div>
                </div>
              ))}

            {!loading &&
              allNotifications?.length > 0 &&
              allNotifications.map((item) => (
                <OverAllNotifcationCardUI
                  key={item.id}
                  data={item}
                  from="all"
                  onStatusChange={(
                    id,
                    status
                  ) =>
                    updateNotificationStatus(
                      id,
                      status
                    )
                  }
                  onDelete={(id) =>
                    deleteNotification(id)
                  }
                />
              ))}

            {!loading &&
              allNotifications?.length === 0 && (
                <div className="flex flex-col items-center justify-center py-16">
                  <img
                    src={NoNotification}
                    alt="No Notifications"
                    className="w-56 mb-5"
                  />

                  <h3 className="text-lg font-semibold text-gray-700">
                    No Notifications Found
                  </h3>

                  <p className="text-sm text-gray-500 mt-2 text-center">
                    You're all caught up. There are no
                    notifications available.
                  </p>
                </div>
              )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OverallNotification;